import { Breadcrumbs } from '@/components/ui/breadcrumbs.tsx'
import type { PpvTrackingCategory } from '@/modules/tracking/ppv/types.ts'
import { PpvCategoryStats } from '@/modules/tracking/ppv/ui/category/PpvCategoryStats.tsx'
import { AppRoutes } from '@/utils/constants.ts'
import { useCreatorUrl } from '@/utils/creators.ts'

interface CategoryTopPageProps {
  category: PpvTrackingCategory
}

export const PpvCategoryTopPage = ({ category }: CategoryTopPageProps) => {
  const ppvUrl = useCreatorUrl(AppRoutes.Creator.ChatterTracking.Ppv.List)

  return (
    <>
      <Breadcrumbs
        breadcrumbs={[
          { name: 'PPV Tracking', to: ppvUrl },
          {
            name: `${
              category.name !== 'uncategorized'
                ? category.name
                : 'Uncategorized'
            }`,
          },
        ]}
      />
      <h2 className="mt-4 text-3xl font-semibold text-title">
        {category.name !== 'uncategorized' ? category.name : 'Uncategorized'}
      </h2>
      <PpvCategoryStats category={category} />
    </>
  )
}
